import {FeaturesEnum} from 'presentation/constants';
import {useHostName} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';

export const useShareAccessFeatureFlag = () => {
	const {isNotredameSaude} = useHostName();

	const {isEnabled} = useFeatureFlag(
		isNotredameSaude
			? FeaturesEnum.PORTAL_FEATURE_SHARE_ACCESS_PPO
			: FeaturesEnum.PORTAL_FEATURE_SHARE_ACCESS,
	);

	return {
		isEnabled,
	};
};
